<template>
  <li class="nav-item active">
    <router-link :to="'/' + id">
      <a class="nav-link" href="#">{{ label }} 
        <div class="sr-only" :class="isActive ? 'active-line' : ''"></div>
      </a>
    </router-link>
  </li>

  <!-- <a class="navbar-brand" href="#">
    {{ label }}
  </a> -->
  <!-- <div
    @click="emitRedirectPage"
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
  >
    <div :class="[isActive ? 'isActive':'', renderClass, 'menuItem']">{{label}}</div>
  </div> -->
</template>

<script>
export default {
  name: "CMenuItem",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    label: String,
    id: String,
    isActive: { type: Boolean, default: false },
    dependancies: Array,
    isError: Boolean,
    isWarning: Boolean,
    isNotReady: Boolean,
    isCalibrated: Boolean
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      isHover: false
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    emitRedirectPage: function () {
      this.$emit("MenuClicked", this.id);
    },
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  computed: {
    renderClass: function() {
      if (this.isError) return 'error';
      else if (this.isWarning) return 'warning';
      else if (this.isNotReady) return 'disabled';
      else return null;
    }
  }
};
</script>

<style lang="scss" scoped>
  .menuItem {
    font-size: 1.2vw;
  }

  .active-line {
    height: 2px;
    background: $active;
    width: 30%;
  }
</style>
